var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{attrs:{"href":_vm.pathDestination.fileLink,"title":"test","target":"_blank"}},[_vm._v(_vm._s(_vm.linkLabel))])])
}
var staticRenderFns = []

export { render, staticRenderFns }